import AdminAllOrganization from './components/admin/AdminAllOrganization';
import AdminAllUsers from './components/admin/AdminAllUsers';
import AdminOrganization from './components/admin/EditOrganization';
import AdminSites from './components/admin/AdminSites';
import AdminUser from './components/admin/EditUser';
import HomePage from './components/common/HomePage';
import NotFoundPage from './components/common/NotFoundPage';
import ReviewInvoicingPage from './components/invoicing/review/ReviewInvoicingPage';
import AdSlotPage from './components/showcase/ad-slots/page/EditAdSlotPage';
import FirmPage from './components/showcase/firms/FirmPage';
import ListingPage from './components/showcase/listings/ListingPage';
import RepPage from './components/showcase/reps/RepPage';
import LoginPage from './components/user/LoginPage';
import { requireLogin } from './utils/guards';
import EditSite from './components/admin/EditSite';
import ResetPasswordPage from './components/user/ResetPasswordPage';
import FirmSearchPage from './components/showcase/firms/FirmSearchPage';
import ListingSearchPage from './components/showcase/listings/ListingSearchPage';
import AdSlotsSearchPage from './components/showcase/ad-slots/AdSlotsSearchPage';
import CreateAdSlotPage from './components/showcase/ad-slots/page/CreateAdSlotPage';
import AddListingPage from './components/showcase/listings/AddListingPage';
import DailyDigestSearch from './components/email/daily-digest/DailyDigestSearch';
import AddDailyDigest from './components/email/daily-digest/AddDailyDigest.js';
import EmailTemplateSearch from './components/admin/email-templates/EmailTemplateSearch';
import AddEmailTemplateModal from './components/admin/email-templates/AddEmailTemplate';
import HomesOfTheWeekSearch from './components/email/hotw/HomesOfTheWeekSearch';
import AddHomesOfTheWeek from './components/email/hotw/AddHomesOfTheWeek';
import PromoAlertSearch from './components/email/promo/PromoAlertSearch';
import AddPromoAlert from './components/email/promo/AddPromoAlert';
import CityRinkSearch from './components/email/city-rink/CityRinkSearch';
import AddCityRink from './components/email/city-rink/AddCityRink';
import MyInvoicesPage from './components/invoicing/search/MyInvoicesPage';
import AddInvoicePage from './components/invoicing/search/AddInvoicePage';
import PhotosPage from './components/photos/PhotosPage';
import EditPhotosPage from './components/photos/EditPhotosPage';
import AddPhotoPage from './components/photos/AddPhotoPage';
import RepSearchPage from './components/showcase/reps/RepSearchPage';
import SpecialSeriesPage from './components/content/series/SeriesSearchPage';
import ArticlesPage from './components/content/posts/ArticlesPage';
import EventsPage from './components/content/events/EventsPage';
import CharityPage from './components/content/charity/CharityPage';
import CityGuidePage from './components/content/places/CityGuidePage';
import EditSeriesPage from './components/content/series/EditSeriesPage';
import NewsAlert from './components/email/news-alert/NewsAlert';
import NewsAlertSearch from './components/email/news-alert/NewsAlertSearch';
import ProfilePage from './components/user/ProfilePage';
import ChatPage from './components/chat/Chat';
import Stats from './components/chat/Stats';

export const URL_REGEX = /^((?:https?:\/\/)?[^./]+(?:\.[^./]+)+(?:\/.*)?)$/;

const mapToOptionsList = list =>
  list.sort().map((item, index) => {
    return { key: index, value: item, text: item };
  });

export const sites = mapToOptionsList([
  '',
  'austin.culturemap.com',
  'dallas.culturemap.com',
  'fortworth.culturemap.com',
  'houston.culturemap.com',
  'sanantonio.culturemap.com',
]);

export const PLACEHOLDER_PHOTO_URL =
  'https://res.cloudinary.com/culturemap-com/image/upload/v1621713532/photos/image.png';

export const defaultImages = {
  PHOTO_PLACEHOLDER: 'https://res.cloudinary.com/culturemap-com/image/upload/v1621713532/photos/image.png',
};

export const rebelmouseIdSiteMap = {
  20308467: 'https://austin.culturemap.com',
  19034226: 'https://sanantonio.culturemap.com',
  19034206: 'https://houston.culturemap.com',
  19034195: 'https://fortworth.culturemap.com',
  19034222: 'https://dallas.culturemap.com',
};

export const rebelmouseGowIdSiteMap = {
  '83ccff5a-27d5-471d-91c8-63936c11fadf': 'https://austin.culturemap.com',
  '6c2904bc-7f31-46e9-8668-9acfbd0150df': 'https://sanantonio.culturemap.com',
  '16a7342a-4213-4c23-9412-5f064835f874': 'https://houston.culturemap.com',
  '4af95764-4aed-44c2-bd87-2a8f5ed5584e': 'https://fortworth.culturemap.com',
  'e6ca00bd-8c66-4eb1-b701-c06a56ebb48e': 'https://dallas.culturemap.com',
};

export const GowIdToRebelMouseIdMap = {
  '83ccff5a-27d5-471d-91c8-63936c11fadf': 20308467,
  '6c2904bc-7f31-46e9-8668-9acfbd0150df': 19034226,
  '16a7342a-4213-4c23-9412-5f064835f874': 19034206,
  '4af95764-4aed-44c2-bd87-2a8f5ed5584e': 19034195,
  'e6ca00bd-8c66-4eb1-b701-c06a56ebb48e': 19034222,
};

export const GowIdToCityNameMap = {
  '83ccff5a-27d5-471d-91c8-63936c11fadf': 'Austin',
  '6c2904bc-7f31-46e9-8668-9acfbd0150df': 'San Antonio',
  '16a7342a-4213-4c23-9412-5f064835f874': 'Houston',
  '4af95764-4aed-44c2-bd87-2a8f5ed5584e': 'Fort Worth',
  'e6ca00bd-8c66-4eb1-b701-c06a56ebb48e': 'Dallas',
};

export const rebelMouseIdToGowIdMap = {
  20308467: '83ccff5a-27d5-471d-91c8-63936c11fadf',
  19034226: '6c2904bc-7f31-46e9-8668-9acfbd0150df',
  19034206: '16a7342a-4213-4c23-9412-5f064835f874',
  19034195: '4af95764-4aed-44c2-bd87-2a8f5ed5584e',
  19034222: 'e6ca00bd-8c66-4eb1-b701-c06a56ebb48e',
};

const getServerUrl = () => {
  const hostName = window.location.host;
  let serverUrl;

  switch (hostName) {
    case 'localhost:3000':
      serverUrl = '//localhost';
      break;
    case 'localhost:3001':
      serverUrl = '//localhost';
      break;
    case 'portal.culturemap.com':
      serverUrl = '//gow-media-server.herokuapp.com';
      break;
    case 'test.culturemap.com':
      serverUrl = '//gow-test-server.herokuapp.com';
      break;
    default:
      serverUrl = '//gow-media-server.herokuapp.com';
      break;
  }

  return serverUrl;
};

export const SERVER_URL = getServerUrl();

// isDev ? '//localhost' : '//gow-media-server.herokuapp.com';

export const properties = mapToOptionsList(['', 'CultureMap', 'SportsMap', 'AutomativeMap', 'InnovationMap']);

export const cities = mapToOptionsList(['', 'Houston', 'San Antonio', 'Dallas', 'Austin', 'Fort Worth']);

export const roles = mapToOptionsList([
  'admin',
  'author',
  'contributor',
  'content-posts',
  'content-activity',
  'editor',
  'events',
  'my-invoices',
  'submit-invoice',
  'review-invoices',
  'email-campaign',
  'email-designer',
  'event-emails',
  'event-flag',
  'charity-emails',
  'ad-slot',
  'firm',
  'listing',
  'rep',
]);

export const adSlotTypes = mapToOptionsList(['Real Estate', 'Product']);

const guards = [requireLogin];

export const routes = [
  {
    // group: 'Chat',
    route: 'reporting',
    title: 'Reporting',
    role: ['admin'],
    component: ChatPage,
    guards,
  },
  {
    // group: 'Chat',
    route: 'reporting-stats',
    title: 'Reporting Stats',
    role: ['admin'],
    component: Stats,
    guards,
  },
  {
    group: 'Articles',
    route: 'articles',
    title: 'Articles',
    role: ['author', 'admin', 'contributor', 'editor'],
    component: ArticlesPage,
    guards,
  },
  {
    group: 'Events',
    route: 'events',
    title: 'Events',
    role: ['admin', 'editor', 'events'],
    component: EventsPage,
    guards,
  },
  {
    group: 'Series',
    route: 'series',
    title: 'Series',
    role: ['admin', 'editor', 'series'],
    component: SpecialSeriesPage,
    guards,
  },
  {
    group: 'Series',
    route: 'series/:siteId/edit/:seriesId',
    title: 'Edit Series',
    role: ['admin', 'editor', 'series'],
    isChild: true,
    component: EditSeriesPage,
    guards,
  },
  {
    group: 'Other Content',
    route: 'charity',
    title: 'Charity Guide',
    role: ['editor', 'admin'],
    component: CharityPage,
    guards,
  },
  {
    group: 'Other Content',
    route: 'places',
    title: 'City Guide',
    role: ['admin'],
    component: CityGuidePage,
    guards,
  },
  {
    group: 'Photos',
    route: 'photos/add',
    title: 'Add Photo',
    role: ['admin'],
    isChild: true,
    component: AddPhotoPage,
    guards,
  },
  {
    group: 'Photos',
    route: 'photos/:id',
    title: 'Edit Photos',
    role: ['admin'],
    isChild: true,
    component: EditPhotosPage,
    guards,
  },
  {
    group: 'Photos',
    route: 'photos',
    title: 'Photos',
    role: ['admin'],
    component: PhotosPage,
    guards,
  },

  {
    group: 'Email Campaigns',
    route: 'daily-digest/create/:id?',
    title: 'Create Daily Digest',
    role: ['editor', 'admin'],
    isChild: true,
    component: AddDailyDigest,
    guards,
  },
  {
    group: 'Email Campaigns',
    route: 'daily-digest',
    title: 'Daily Digest',
    role: ['editor', 'admin', 'email-campaign'],
    component: DailyDigestSearch,
    guards,
  },
  {
    group: 'Email Campaigns',
    route: 'promo-alert/create/:id?',
    title: 'Promo Alerts',
    role: ['editor', 'admin', 'email-campaign'],
    isChild: true,
    component: AddPromoAlert,
    guards,
  },
  {
    group: 'Email Campaigns',
    route: 'promo-alert',
    title: 'Promo Alerts',
    role: ['editor', 'admin', 'email-campaign'],
    component: PromoAlertSearch,
    guards,
  },
  {
    group: 'Email Campaigns',
    route: 'city-rink/create/:id?',
    title: 'City Rink',
    role: ['editor', 'admin', 'email-campaign'],
    isChild: true,
    component: AddCityRink,
    guards,
  },
  {
    group: 'Email Campaigns',
    route: 'city-rink',
    title: 'City Rink',
    role: ['editor', 'admin', 'email-campaign'],
    component: CityRinkSearch,
    guards,
  },

  {
    group: 'Email Campaigns',
    route: 'hotw/create/:id?',
    title: 'Homes of the Week',
    role: ['editor', 'admin', 'email-campaign'],
    component: AddHomesOfTheWeek,
    isChild: true,
    guards,
  },
  {
    group: 'Email Campaigns',
    route: 'hotw',
    title: 'Homes of the Week',
    role: ['editor', 'admin', 'email-campaign'],
    component: HomesOfTheWeekSearch,
    guards,
  },

  {
    group: 'Showcase',
    route: 'ad-slot/create',
    title: 'Create Ad Slot',
    role: ['ad-slot', 'admin'],
    component: CreateAdSlotPage,
    guards,
    isChild: true,
  },
  {
    group: 'Showcase',
    route: 'ad-slot/:id',
    title: 'Ad Slots',
    role: ['ad-slot', 'admin'],
    component: AdSlotPage,
    guards,
    isChild: true,
  },
  {
    group: 'Showcase',
    route: 'ad-slot',
    title: 'Ad Slots',
    role: ['ad-slot', 'admin'],
    component: AdSlotsSearchPage,
    guards,
  },
  {
    group: 'Showcase',
    route: 'firm/:id',
    title: 'Firms',
    role: ['firm', 'admin'],
    component: FirmPage,
    guards,
    isChild: true,
  },
  {
    group: 'Showcase',
    route: 'firm',
    title: 'Firms',
    role: ['firm', 'admin'],
    component: FirmSearchPage,
    guards,
  },
  {
    group: 'Showcase',
    route: 'listing/add',
    title: 'Listings',
    role: ['listing', 'admin'],
    component: AddListingPage,
    guards,
    isChild: true,
  },
  {
    group: 'Showcase',
    route: 'listing/:id',
    title: 'Listings',
    role: ['listing', 'admin'],
    component: ListingPage,
    guards,
    isChild: true,
  },
  {
    group: 'Showcase',
    route: 'listing',
    title: 'Listings',
    role: ['listing', 'admin'],
    component: ListingSearchPage,
    guards,
  },
  {
    group: 'Showcase',
    route: 'rep/:id',
    title: 'Realtors',
    role: ['rep', 'admin'],
    component: RepPage,
    guards,
    isChild: true,
  },
  { group: 'Showcase', route: 'rep', title: 'Realtors', role: ['rep'], component: RepSearchPage, guards },

  {
    group: 'Invoicing',
    route: 'invoice',
    title: 'Add Invoices',
    role: ['author', 'editor', 'contributor', 'admin'],
    component: AddInvoicePage,
    isChild: true,
    guards,
  },
  {
    group: 'Invoicing',
    route: 'my-invoices',
    title: 'My Invoices',
    role: ['author', 'contributor', 'editor', 'admin'],
    component: MyInvoicesPage,
    guards,
  },
  {
    group: 'Invoicing',
    route: 'review-invoices',
    title: 'Review Invoices',
    role: ['editor', 'admin'],
    component: ReviewInvoicingPage,
    guards,
  },
  {
    group: 'Admin',
    route: 'admin/user/:id',
    title: 'Users',
    role: ['admin'],
    component: AdminUser,
    guards,
    isChild: true,
  },
  {
    group: 'Admin',
    route: 'admin/user',
    title: 'Users',
    role: ['admin'],
    component: AdminAllUsers,
    guards,
  },
  {
    group: 'Admin',
    route: 'admin/email-template/edit/:id',
    title: 'Edit email template',
    role: ['admin'],
    component: AddEmailTemplateModal,
    isChild: true,
    guards,
  },
  {
    group: 'Admin',
    route: 'admin/email-template/add',
    title: 'Create email template',
    role: ['admin'],
    component: AddEmailTemplateModal,
    isChild: true,
    guards,
  },
  {
    group: 'Admin',
    route: 'admin/email-template',
    title: 'Email templates',
    role: ['admin'],
    component: EmailTemplateSearch,
    guards,
  },
  {
    group: 'Admin',
    route: 'admin/organization/:id',
    title: 'Organizations',
    role: ['admin'],
    component: AdminOrganization,
    guards,
    isChild: true,
  },
  {
    group: 'Admin',
    route: 'admin/organization',
    title: 'Organizations',
    role: ['admin'],
    component: AdminAllOrganization,
    guards,
  },
  {
    group: 'Admin',
    route: 'admin/site/:id',
    title: 'Sites',
    role: ['admin'],
    component: EditSite,
    guards,
    isChild: true,
  },
  {
    group: 'Admin',
    route: 'admin/site',
    title: 'Sites',
    role: ['admin'],
    component: AdminSites,
    guards,
  },
  {
    group: '',
    route: 'reset-password/:token',
    role: [],
    component: ResetPasswordPage,
  },
  {
    group: '',
    route: 'login',
    role: [],
    component: LoginPage,
    forceRefresh: true,
  },
  {
    group: '',
    route: 'profile',
    title: 'profile',
    role: [],
    component: ProfilePage,
  },
  { group: '', route: '', role: '', component: LoginPage },
  { group: '', route: 'home', role: '', component: HomePage, guards },
  { group: '', route: '*', role: '', component: NotFoundPage, guards },
];
